let html = `<div class="broadcast">
    <div class="broadcast__text">{text}</div>

    <div class="broadcast__scan"><div></div></div>

    <div class="broadcast__devices">
    
    </div>
</div>`

export default html